import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { Queries } from './queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./queries";
var LabelsApi = /** @class */ (function () {
    function LabelsApi(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    LabelsApi.prototype.getLabels = function (where, offset) {
        return this.apollo
            .query({
            query: this.queries.getLabels(),
            variables: {
                where: where,
                offset: offset
            }
        })
            .pipe(map(function (_a) {
            var data = _a.data;
            return data['labels'];
        }));
    };
    LabelsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LabelsApi_Factory() { return new LabelsApi(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.Queries)); }, token: LabelsApi, providedIn: "root" });
    return LabelsApi;
}());
export { LabelsApi };
